import { useContext } from 'react';
import { MyPortfolioTableContext, IMyPortfolioTableContext } from './MyPortfolioTableContext';

export const useClientDetailsTable = () => useContext<IMyPortfolioTableContext>(MyPortfolioTableContext);
